export default __webpack_public_path__ + "media/color/sphtx-b74999db.svg";